import { useEffect } from 'react';
import { getScroll, pageWrapper, scrollSource } from '../helpers/helpers';

export const useInfiniteScroll = (fn: () => any, hasNext?: boolean, scrollContainer?: HTMLElement | null, isLoading?: boolean, loadOnMount = true) => {
    let { isAtEnd } = getScroll(scrollContainer || pageWrapper);

    const handleScroll = () => {
        const { isAtEnd } = getScroll(scrollContainer || pageWrapper);

        if (isAtEnd && hasNext && !isLoading) {
            fn();
        }
    };

    useEffect(() => {
        (scrollContainer || scrollSource).addEventListener('scroll', handleScroll);
        return () => (scrollContainer || scrollSource).removeEventListener('scroll', handleScroll);
    }, [scrollContainer, fn, hasNext, isLoading]);

    useEffect(() => {
        if (!loadOnMount) return;

        let { isAtEnd } = getScroll(scrollContainer || pageWrapper);

        if (isAtEnd && hasNext && !isLoading) {
            fn();
        }
    }, [isAtEnd, fn, hasNext, isLoading, scrollContainer, loadOnMount]);
};
